export default __webpack_public_path__ + "static/media/bihorel12.5ffefe8d.jpg";